import { type IconDefinition, faCircle } from '@fortawesome/free-regular-svg-icons';
import {
  faCheckCircle,
  faCircleExclamation,
  faCircleXmark,
  faFileCircleExclamation,
  faListCheck,
  faPeopleArrows,
  faPersonWalkingArrowLoopLeft,
  faUser,
  faUserEdit
} from '@fortawesome/free-solid-svg-icons';
import { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';

/**
 * Get fontawesome icons for the mark status
 */
export const getMarkStatusIcon = (status: MarkStatus): IconDefinition => {
  switch (status) {
    case MarkStatus.Assigned:
      return faUser;
    case MarkStatus.InProgress:
      return faUserEdit;
    case MarkStatus.NeedsReview:
      return faCircleExclamation;
    case MarkStatus.InReview:
      return faListCheck;
    case MarkStatus.ReturnedForMarking:
      return faPeopleArrows;
    case MarkStatus.FurtherEscalated:
      return faFileCircleExclamation;
    case MarkStatus.Reassigned:
      return faPersonWalkingArrowLoopLeft;
    case MarkStatus.FinishedSuccess:
      return faCheckCircle;
    case MarkStatus.FinishedFailure:
      return faCircleXmark;
    default:
      return faCircle;
  }
};

export const statusesOfFinishedMarks = [MarkStatus.FinishedSuccess, MarkStatus.FinishedFailure];

export function statusesOfUnfinishedMarks(): MarkStatus[] {
  return Object.values(MarkStatus).filter(
    (status) => ![MarkStatus.Assigned].concat(statusesOfFinishedMarks).includes(status)
  );
}

export function isMarkFinished(markStatus: MarkStatus): boolean {
  return statusesOfFinishedMarks.includes(markStatus);
}
